import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type {
  AssessmentsAccumulationMappingsResponse,
  AssessmentsAccumulationResponse,
} from '@/entities/assessments/api/generated/model';
import type { AmountUnit } from '@/shared/lib/amount/convertAmount';
import { Table } from '@/shared/ui';
import { FIRST_COLUMN_WIDTH } from '../helpers/assessment-table-columns';
import { createDefaultAccumulationsTableColumns } from '../helpers/default-accumulations-columns';
import { formatDefaultAccumulationsTableData } from '../helpers/formatted-default-accumulations-table-data';

type AccumulationsTableProps = {
  /** 積算明細データ */
  accumulationData: AssessmentsAccumulationResponse | AssessmentsAccumulationMappingsResponse;
  /** 基準年度 */
  baseFiscalYear: number;
  /** 比較年度 */
  comparedFiscalYear: number;
  /** 金額単位 */
  amountUnit: AmountUnit;
  isSidePanelView?: boolean;
};

/**
 * 年度明細用の積算明細テーブルコンポーネント
 */
export const DefaultAccumulationsTable: FC<AccumulationsTableProps> = ({
  accumulationData,
  baseFiscalYear,
  comparedFiscalYear,
  amountUnit,
  isSidePanelView = false,
}) => {
  const { t } = useTranslation();

  const formattedData = formatDefaultAccumulationsTableData(accumulationData);

  const columns = createDefaultAccumulationsTableColumns({
    baseFiscalYear,
    comparedFiscalYear,
    amountUnit,
    isSidePanelView,
    t,
  });

  return (
    <div
      className={isSidePanelView ? undefined : 'grid w-full'}
      style={isSidePanelView ? undefined : { gridTemplateColumns: `${FIRST_COLUMN_WIDTH}px 1fr` }}
    >
      {!isSidePanelView && <div className="border-border-strength1 border-r bg-surface-base" />}
      <Table
        columns={columns}
        data={formattedData}
        pagination={null}
        showLastBorderBottom={isSidePanelView}
      />
    </div>
  );
};
